module.exports = __webpack_public_path__ + "img/camel-comb3-1.33dbc5c1.jpg";